import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Header from '../../Header/Header';
import { history } from '../../helpers/history';
import Celebrity from './celebrity';
import { Helmet } from 'react-helmet';
import HomeSlidTabs from '../Home/HomeSlidTabs';
import Footer from '../../Footer/Footer';

class Promotion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bannerList: [],
            Promotionrule: [
                { "offertype": "LAUNCH EXTRAVAGANZA", "offer_quote": "Offer Lasts Only 3 Weeks After Launch.", "img_no": 5, "date": "offer", "url": "/PromotionRules" },
                { "offertype": "", "offer_quote": "We are thrilled to announce a significant change to our Super6 Raffle and Draw!", "img_no": 5, "date": "offer", "url": "/OfferSuper6" },
                { "offertype": "", "offer_quote": "We are thrilled to announce an exciting change to our raffle event! The Fortune4 Raffle is evolving into Fortune6, bringing even more opportunities for you to win incredible prizes!", "img_no": 5, "date": "offer", "url": "/Offerfortune6" },
            ],
            UserCountry: localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {}
        };
    }

    OfferDetails = (Obj) => {
        if (Obj && Obj.url) {
            history.push(Obj.url)
        }
    }


    render() {
        const { t } = this.props;
        return (
            <>
                {
                    process.env.REACT_APP_MODE != "development" && <Helmet>
                        {Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my' ?
                            <title>Live Results & Promotions – Maximize Gulf Ticket Winnings in Malaysia
                            </title> :
                            <title>Promo Draw Results Online | Reward List and Lucky Winner Board | Gulf Ticket</title>}

                        {Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my' ?
                            <meta name="description" content="Discover Gulf Ticket live results and promotions for Malaysia. Learn how to win more with referral games like Magic 5, Fortune 4, and Super 6. Play smart, win big.
                            " /> :
                            <meta name="description" content="Stay informed on Gulf Ticket’s promotional draws, lucky winners, and ongoing prize campaigns. Get your updates and win exclusive rewards today." />}

                    </Helmet>
                }
                <>
                    <Header />
                    <div class="container">
                        <HomeSlidTabs />
                        <div class="rht bg2 content">
                            <div class="bredCrums">
                                <ul>
                                    <li><a onClick={() => { history.push('/') }}>  {t('lblHome')} <img src="./assets/img/icons/right-angle.png" /></a></li>
                                    <li><a class="active">{t('lblPromotion')}</a></li>
                                </ul>
                            </div>
                            <Celebrity />
                            <Footer/>
                        </div>
                        {/* <div className="wrap1">
                            <h1 className="headding8 floatNone">
                                {Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my' ?
                                    'Live Promo Results – See Latest Lucky Winners Now' :
                                    'Live Promo Results – See Latest Lucky Winners Now'}
                            </h1>
                            <div className="row">
                                <div className="pastDrawResultsSection marginBottomResult">
                                    {this.state.Promotionrule && this.state.Promotionrule.map((x, inx) =>
                                        <div className="pastDrawResultSubSection bg-white" key={`bg_${inx}`}>
                                            {inx == 0 && <div className={`dateAbsoluteSection bg-game9`}>{x.date}</div>}
                                            <div className="WinningContainer">
                                                <div className="WinningCome solid-border paddingNone">
                                                    <img src={`./assets/img/promotion/promotions-${x.img_no}.png?v0.1`} alt="promotions icon" srcset="" />
                                                </div>
                                                <div className="solid-border solid-border-1 paddingNone margin0 text-left promotionRulesCont">
                                                    <p>{x.offertype}</p>
                                                    <span>{x.offer_quote}</span>
                                                </div>
                                                <div className="detailsSection">
                                                    <a onClick={() => { this.OfferDetails(x) }}><img src="./assets/img/icons/Notes-3.svg" alt="details" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div> */}
                    </div>
                </ >
            </>
        )
    }
}
export default withTranslation()(Promotion)